import { render, staticRenderFns } from "./AiDisease.vue?vue&type=template&id=0cee7b9b&scoped=true"
import script from "./AiDisease.vue?vue&type=script&lang=js"
export * from "./AiDisease.vue?vue&type=script&lang=js"
import style0 from "./AiDisease.vue?vue&type=style&index=0&id=0cee7b9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cee7b9b",
  null
  
)

export default component.exports